import { structEq } from './equals';
export const DEV_ENV = typeof process !== 'undefined' && process.env.NODE_ENV !== 'production';
export function setKey(k, v, o) {
    if (k in o && structEq(v, o[k])) {
        return o;
    }
    else {
        // this is the fastest way to do it, see
        // https://jsperf.com/focal-setkey-for-loop-vs-object-assign
        const r = {};
        for (const p in o)
            r[p] = o[p];
        r[k] = v;
        return r;
    }
}
/**
 * 'Conserve' a value's identity if its structure doesn't change.
 */
function conserve(x, y) {
    return structEq(x, y) ? y : x;
}
/**
 * Make a fold function's behaviour conservative in its input value's
 * identity.
 */
export function conservatively(fn) {
    return (y, c0) => conserve(fn(y, c0), c0);
}
export function findIndex(xs, p) {
    for (let i = 0; i < xs.length; i++) {
        if (p(xs[i]))
            return i;
    }
    return -1;
}
export function warning(message) {
    if (typeof console !== 'undefined' && typeof console.error === 'function') {
        console.error('[Focal]: ' + message); // tslint:disable-line no-console
    }
    // Throw a dummy error so it's possible to enter debugger with
    // 'break on all exceptions'.
    try {
        throw new Error(message);
    }
    catch (_) { /* no-op */ }
}
//# sourceMappingURL=utils.js.map